import axios from "axios"
import { useAuth0 } from "@auth0/auth0-react"
import { useQuery } from "@tanstack/react-query"
import { useDispatch } from "react-redux"
import { setUserData } from "../features/users/userSlice"

const useFetchUser = () => {
	const dispatch = useDispatch()
	const { getAccessTokenSilently, isAuthenticated } = useAuth0()

	const { data } = useQuery({
		queryKey: ["user"],
		queryFn: async () => {
			const token = await getAccessTokenSilently({
				authorizationParams: { audience: process.env.REACT_APP_API_IDENTIFIER },
				scope: "openid profile email offline_access"
			})
			const response = await axios.get(
				`${process.env.REACT_APP_BACKEND_URL}/api/user`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			// Hydrate UI preferences (select / viewMode / colorScheme / columnCount /
			// chairListView / nurseListView) into Redux. Server data (termsAccepted)
			// is read directly from this query's return value below.
			dispatch(setUserData(response.data.payload))
			return response.data.payload
		},
		enabled: isAuthenticated,
		staleTime: 1000 * 60 * 30,
		refetchOnMount: "always"
	})

	return data
}

export default useFetchUser
